import "./work-card.css"
import { useRootContext } from "../../hooks/useRootContext";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";

function WorkCard({ data }) {
    const { title, description, img, url } = data;

    const { setIsRouteLoading } = useRootContext();

    const navigate = useNavigate();

    return (
        <div className="work-card">
            <LazyLoadImage
                effect="blur"
                src={img}
                alt={`${title} Work Image`}
                onClick={() => {
                    navigate(url);
                    setIsRouteLoading(true);
                }}
            />
            <h1>{title}</h1>
            <p>
                {description}
            </p>
            <button onClick={() => {
                navigate(url);
                setIsRouteLoading(true);
            }}>
                View Project
            </button>
        </div>
    )
}

export default WorkCard
